((w) => {
    
    w.PubSub.subscribe('externaltracking.product.detailsview', function (_, productImpression) {
        const productId = (productImpression || {}).productId;
        if (productId) {
            let contentIds = [];

            if (!productImpression.hasVariants) {
                contentIds = [productImpression.productNo ? productImpression.productNo : ('' + productId)];
            } else if (productImpression.isMainProduct && productImpression.variantProducts && productImpression.variantProducts.length) {
                contentIds = productImpression.variantProducts.map(variant => variant.productNo ? variant.productNo : ('' + variant.productId));
            }

            if (contentIds.length) {
                w.fbq('track', 'ViewContent', {
                    content_ids: contentIds,
                    content_type: 'product',
                    content_name: productImpression.name,
                    content_brand: productImpression.brand,
                    currency: productImpression.currencyCode,
                    value: parseFloat(productImpression.price)
                });
            }
        }
    }); 

})(window);